(function($) {

    function setTabs ($tabContainer) {

        //get ActiveTab within the tab container
        var activeTab = $($tabContainer.querySelector('.sbtl-tab[aria-selected="true"]'));

        var activeTabBody = $("#" + activeTab.attr('aria-controls'));

        activeTabBody.show();

        // Hide all other tab bodies in the tab container
        $(activeTab).siblings().each(function() {
            var tabBody = $("#" + $(this).attr('aria-controls'));
            tabBody.hide();
        });

    }

    $('.sbtl-tab').on('click', function() {

        $(this).attr('aria-selected', 'true');
        $(this).siblings().attr('aria-selected', 'false');

        setTabs($tabContainer);
    });

    $tabContainers = document.querySelectorAll('.sbtl-tabs');

    // Loop through each tab container
    $tabContainers.forEach(function($tabContainer) {
        setTabs($tabContainer);

        // Add click event to each tab container's .sbt-tab
        $tabContainer.querySelectorAll('.sbtl-tab').forEach(function($tab) {
            $tab.addEventListener('click', function() {
                $($tab).attr('aria-selected', 'true');
                $($tab).siblings().attr('aria-selected', 'false');
                setTabs($tabContainer);
            });
        });
    });


} )( jQuery );